import { createSelector } from "@reduxjs/toolkit";
import { selectHttpMcbimSpacesResult } from "./httpMcBimSelectors";
import { selectMcBimItemsForViewer } from "./mcbimItemSelectors";

// Unika McBIM-space-namn (för att bygga roomNumbers-lista)
export const selectUniqueMcbimSpaceNames = createSelector(
  selectHttpMcbimSpacesResult,
  (res): string[] => {
    const data = (res as Array<{ name?: string }> | undefined) ?? [];
    const seen = new Set<string>();
    const out: string[] = [];

    for (const s of data) {
      const n = s?.name;
      if (n && !seen.has(n)) {
        seen.add(n);
        out.push(n);
      }
    }

    return out;
  }
);

export const selectUniqueVisibleMcbimFileNames = createSelector(
  [selectMcBimItemsForViewer, selectHttpMcbimSpacesResult],
  (items, spaces): string[] => {
    const seen = new Set<string>();
    const out: string[] = [];

    for (const entry of [...items, ...spaces] as Array<{ fileName?: string | null }>) {
      const fileName = entry.fileName?.trim();
      if (!fileName || seen.has(fileName)) continue;

      seen.add(fileName);
      out.push(fileName);
    }

    return out.sort((a, b) => a.localeCompare(b));
  }
);
